import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { User } from '@app/@auth';
import { DxFormComponent } from 'devextreme-angular';

@Component({
  selector: 'app-login-form',
  templateUrl: './login-form.component.html',
  styleUrls: ['./login-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginFormComponent implements OnInit {
  @Input() user!: Partial<User>;
  @Input() loading!: boolean;
  @Input() error!: string;
  @Output() submit = new EventEmitter();

  @ViewChild(DxFormComponent) loginForm!: DxFormComponent;

  submitted = false;

  constructor() {
    this.onSubmit = this.onSubmit.bind(this);
    this.onEnterKey = this.onEnterKey.bind(this);
  }

  ngOnInit(): void {}

  onEnterKey(e) {
    this.submitted = true;
    const { isValid } = this.loginForm.instance.validate();
    if (isValid) {
      this.submit.emit({
        usuario: this.user.usuario,
        password: this.user.password,
      });
    }
  }

  onSubmit(e) {
    this.submitted = true;
    const { isValid } = this.loginForm.instance.validate();
    if (isValid) {
      this.submit.emit({
        usuario: this.user.usuario,
        password: this.user.password,
      });
    }
  }
}
